import { DPRWebSocket } from './DPRWebSocket';


export const websocket = new DPRWebSocket();
